__turbopack_context__.v({
  "button": "LKG3JW_button",
  "link": "LKG3JW_link",
});
